__turbopack_context__.v({
  "accordionLabel": "FireflyReframeDialog-module__DzNomq__accordionLabel",
  "body": "FireflyReframeDialog-module__DzNomq__body",
  "chevron": "FireflyReframeDialog-module__DzNomq__chevron",
  "fieldGroup": "FireflyReframeDialog-module__DzNomq__fieldGroup",
  "labelRow": "FireflyReframeDialog-module__DzNomq__labelRow",
  "processingItemRow": "FireflyReframeDialog-module__DzNomq__processingItemRow",
  "ratioCard": "FireflyReframeDialog-module__DzNomq__ratioCard",
  "ratioGrid": "FireflyReframeDialog-module__DzNomq__ratioGrid",
  "ratioPreview": "FireflyReframeDialog-module__DzNomq__ratioPreview",
  "toggleCheckbox": "FireflyReframeDialog-module__DzNomq__toggleCheckbox",
  "toggleWrapper": "FireflyReframeDialog-module__DzNomq__toggleWrapper",
  "validationAccordion": "FireflyReframeDialog-module__DzNomq__validationAccordion",
  "validationAccordionContent": "FireflyReframeDialog-module__DzNomq__validationAccordionContent",
  "validationAccordionHeader": "FireflyReframeDialog-module__DzNomq__validationAccordionHeader",
  "validationItemContent": "FireflyReframeDialog-module__DzNomq__validationItemContent",
  "validationList": "FireflyReframeDialog-module__DzNomq__validationList",
  "validationListContainer": "FireflyReframeDialog-module__DzNomq__validationListContainer",
  "validationListItem": "FireflyReframeDialog-module__DzNomq__validationListItem",
});
